import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import ResourcesOverview from "./sections/ResourcesOverview";
import CapabilityStatement from "./sections/CapabilityStatement";
import ExpressionOfInterestAssetWarehouseCarparkProtection from "./sections/ExpressionOfInterestAssetWarehouseCarparkProtection";
import ExpressionOfInterestWetAreaPcItemsAmbulantAccessories from "./sections/ExpressionOfInterestWetAreaPcItemsAmbulantAccessories";
import ExpressionOfInterestDoorFurnitureThresholds from "./sections/ExpressionOfInterestDoorFurnitureThresholds";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <ResourcesOverview />
      <CapabilityStatement />
      <ExpressionOfInterestAssetWarehouseCarparkProtection />
      <ExpressionOfInterestWetAreaPcItemsAmbulantAccessories />
      <ExpressionOfInterestDoorFurnitureThresholds />
      <Footer />
    </div>;
}